const params = new URLSearchParams(window.location.search);
const errorDescription = params.get('error_description');

const redirectSignIn = errorDescription?.includes('Account is setup')
  ? window.location.href
  : process.env.REACT_APP_REDIRECT_SIGNIN;

export default {
  Auth: {
    // REQUIRED - Amazon Cognito Identity Pool ID
    identityPoolId: process.env.REACT_APP_COGNITO_IDENTITY_POOL_ID,
    // REQUIRED - Amazon Cognito Region
    region: process.env.REACT_APP_AWS_REGION,
    // OPTIONAL - Amazon Cognito User Pool ID
    userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID,
    // OPTIONAL - Amazon Cognito Web Client ID
    userPoolWebClientId: process.env.REACT_APP_USER_POOL_WEB_CLIENT_ID,
  },
  Storage: {
    // REQUIRED -  Amazon S3 bucket
    bucket: process.env.REACT_APP_USER_UPLOAD_S3_BUCKET,
    // REQUIRED -  bucket region
    region: process.env.REACT_APP_AWS_REGION,
    // LEVEL
    level: 'private',
  },
  oauth: {
    domain: process.env.REACT_APP_DOMAIN,
    scope: [
      'phone',
      'email',
      'profile',
      'openid',
      'aws.cognito.signin.user.admin',
    ],
    redirectSignIn,
    redirectSignOut: process.env.REACT_APP_REDIRECT_SIGNOUT,
    responseType: process.env.REACT_APP_AUTH_RESPONSETYPE,
  },
};
